/**
 * Chart type ids for the item-list summary strip.
 * Pipeline/`status` was retired — coerce legacy persisted values to Category.
 */

export type ChartType = 'category' | 'altitude' | 'lineage' | 'completeness';

export function coerceChartType(value: string | null | undefined): ChartType {
  if (value === 'category' || value === 'altitude' || value === 'lineage' || value === 'completeness') {
    return value;
  }
  return 'category';
}
